// Mock data for process dashboard components
export const mockProcessCosts = [
  {
    processId: 'process-1',
    activityCosts: [
      {
        activity: 'Picking',
        laborCost: 5000,
        equipmentCost: 1000,
        overheadCost: 2000,
      },
      {
        activity: 'Packing',
        laborCost: 3000,
        equipmentCost: 500,
        overheadCost: 1000,
      },
      {
        activity: 'Shipping',
        laborCost: 2000,
        equipmentCost: 1500,
        overheadCost: 1500,
      },
    ],
    totalCost: 16500,
    efficiency: 85,
  },
];

export const mockHiddenCosts = {
  stockRearrangements: 15,
  multiTouchCount: 45,
  avgTouchesPerItem: 2.5,
  rearrangementTime: 4.5,
  rearrangementCost: 2500,
};

export const mockPicklistMetrics = {
  avgLinesPerPicklist: 25,
  avgLinesPerOrder: 8,
  avgDistancePerOrder: 120,
  avgTimePerOrder: 15,
  avgDistancePerPicklist: 350,
  avgTimePerPicklist: 45,
  orderDistribution: {
    min: 1,
    max: 15,
    avg: 5,
  },
  pickRate: 45,
};
